// removed by extract-text-webpack-plugin
module.exports = {"icon":"_3qLjQXX1gzjnTVXgp9Ua6i"};


//////////////////
// WEBPACK FOOTER
// ../components/icon/styles.module.css
// module id = 406
// module chunks = 0